// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const API_URL = 'https://shippers.dev.okcargo.io';
const LOCAL_VERSION_URL = 'assets/versions.json';

export const environment = {
  production: false,

  apiUrl: API_URL,
  apiDemoUrl: 'https://shippers.demo.okcargo.io',

  localVersionsUrl: 'assets/versions.json',
  versionsUrl: `${API_URL}/${LOCAL_VERSION_URL}`,

  appNameTagline: 'general.shippers',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
